// extracted by mini-css-extract-plugin
module.exports = {"debug":"sectionGrid_debug__3bq95","sectionGridContainer":"sectionGrid_sectionGridContainer__3q912","content":"sectionGrid_content__3t235","grey":"sectionGrid_grey__16Dzy"};